import { FC } from 'react'

import { IAsyncDownloadState } from '../../model'

import styles from './CircleProgressBar.module.scss'

interface ICircleProgressBarProps {
  download: IAsyncDownloadState
}

export const CircleProgressBar: FC<ICircleProgressBarProps> = ({ download }) => {
  const percent = download.percent ?? 0
  const radius = 42
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (percent / 100) * circumference

  return (
    <div className={styles.progressWrapper}>
      <svg className={styles.progressSvg} viewBox="0 0 100 100">
        <defs>
          <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1976d2" />
            <stop offset="100%" stopColor="#42a5f5" />
          </linearGradient>
        </defs>

        <circle
          className={styles.progressBackground}
          cx="50"
          cy="50"
          r={radius}
          fill="none"
          stroke="#e3f2fd"
          strokeWidth="8"
        />

        {download.percent !== null ? (
          <circle
            className={styles.progressCircle}
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="url(#progressGradient)"
            strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 50 50)"
          />
        ) : (
          <circle
            className={styles.progressSpinner}
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="url(#progressGradient)"
            strokeWidth="8"
            strokeDasharray="80 184"
            strokeLinecap="round"
          />
        )}
      </svg>

      <div className={styles.progressContent}>
        {download.percent !== null ? (
          <div className={styles.percentText}>{download.percent}%</div>
        ) : (
          <div className={styles.dotsContainer}>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
            <span className={styles.dot}></span>
          </div>
        )}
      </div>
    </div>
  )
}
